export default __webpack_public_path__ + "static/media/computer-2982270_1920.b5d4ba47.jpg";